import { Component, OnInit, Inject } from '@angular/core';
import { Produto } from 'src/app/models/produto';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ProdutoService } from 'src/app/services/produto.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoClassificacao } from 'src/app/models/produto-classificacao';
import { OrigemGI } from 'src/app/models/enum';

@Component({
  selector: 'app-detalhe-produto-modal',
  templateUrl: './detalhe-produto-modal.component.html',
  styleUrls: ['./detalhe-produto-modal.component.scss'],
})
export class DetalheProdutoModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};

  produto: Produto;
  foto: any;
  mostrarCodErp: false;
  buscarClassificacao = false;
  classificacoes: ProdutoClassificacao[] = [];
  origemGI: OrigemGI;
  OrigemGI = OrigemGI;

  constructor(
    public dialogRef: MatDialogRef<DetalheProdutoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private premissasService: PremissasService,
    private produtoService: ProdutoService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
  ) {}

  ngOnInit() {
    this.produto = this.data.produto;
    this.buscarClassificacao = this.data.buscarClassificacao;
    this.origemGI = this.data.origemGI;
    this.buscarMostrarCodErp();
    this.buscarProduto();

    if (this.buscarClassificacao) {
      this.buscarClassificacoes();
    }
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarProduto() {
    this.carregandoService.mostra('buscaProduto');

    this.produtoService.consultarImagemProdutoPorId(this.produto.idProduto).subscribe(
      (imagem) => {
        if (imagem && imagem.url) {
          this.foto = imagem.url;
        } else if (imagem && imagem.raw) {
          this.foto = 'data:image/jpg;base64,' + imagem.raw;
        } else {
          this.foto = './assets/img/placeholder.jpg';
        }

        this.carregandoService.esconde('buscaProduto');
      },
      (erro) => {
        this.carregandoService.esconde('buscaProduto');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra('buscarMostrarCodErp');
    this.premissasService.consultarMostrarCodErp().subscribe(
      (f) => {
        this.mostrarCodErp = f.valor;
        this.carregandoService.esconde('buscarMostrarCodErp');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostrarCodErp');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarClassificacoes() {
    this.carregandoService.mostra('buscarClassificacoes');
    this.produtoService.buscarClassificacaoPreenchida(this.produto.idProduto).subscribe(
      (f) => {
        this.classificacoes = f;
        this.carregandoService.esconde('buscarClassificacoes');
      },
      (erro) => {
        this.carregandoService.esconde('buscarClassificacoes');
        this.notificacaoService.erro(erro);
      },
    );
  }

  possuiFoto(): boolean {
    return this.produto.foto || this.produto.fotoUrl;
  }
}
